module.exports = "/_next/static/images/superpotlac-4f0adaa7b49c9dff761f7b7fd48e230f.png";